import { CONTRACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const Contract = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: (isUngated, hasScope) => isUngated('Commerce:ContractsObjectBeta') && hasScope('contracts-access'),
  objectTypeId: CONTRACT_TYPE_ID,
  referenceObjectType: 'CONTRACT_PROPERTIES'
});
export default Contract;